import React, { ComponentType, ReactElement } from 'react';
import Breadcrumbs from 'components/mainComponents/Breadcrumbs';

const withBreadcrumbs = <P extends object>(
  WrappedComponent: ComponentType<P>,
): React.FC<P> => {
  const Wrapper = (props: P): ReactElement => {
    return (
      <div className='content'>
        <Breadcrumbs />
        <WrappedComponent {...props} />
      </div>
    );
  };
  return Wrapper;
};

export default withBreadcrumbs;
